import { render, staticRenderFns } from "./dev-preview.vue?vue&type=template&id=4d499502&scoped=true"
import script from "./dev-preview.vue?vue&type=script&lang=js"
export * from "./dev-preview.vue?vue&type=script&lang=js"
import style0 from "./dev-preview.vue?vue&type=style&index=0&id=4d499502&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d499502",
  null
  
)

export default component.exports